module.exports = __webpack_public_path__ + "img/20190620162415QQ截图20190617163913.60e229b6.png";